import { render, staticRenderFns } from "./ShareAddPeer.vue?vue&type=template&id=105f47b3&"
import script from "./ShareAddPeer.vue?vue&type=script&lang=ts&"
export * from "./ShareAddPeer.vue?vue&type=script&lang=ts&"
import style0 from "./ShareAddPeer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports